import { useFetcher } from "~/hooks/useFetcher";
import { memoriesListPath, type PartialMemory } from "~/services/memories";

interface UseUserMemoriesResult {
  memories: PartialMemory[];
  isLoading: boolean;
  error: unknown;
}

/**
 * Lists the authenticated caller's memories, name-ordered by the service. The
 * endpoint resolves ownership from the auth token, so there is nothing to pass;
 * `enabled` just defers the request until the user context has loaded.
 */
export function useUserMemories(enabled: boolean): UseUserMemoriesResult {
  const { data, isLoading, error } = useFetcher<PartialMemory[]>(
    enabled ? memoriesListPath() : null
  );

  // The gated window is still loading as far as the caller is concerned — SWR
  // reports a null key as settled, which reads as a user with no memories.
  return { memories: data ?? [], isLoading: !enabled || isLoading, error };
}
